import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './MenuBar.scss';
import Cookies from 'js-cookie';

interface MenuBarProps {
    showLogo?: boolean;
}

export function MenuBar({ showLogo = true }: MenuBarProps) {
    const handleLanguageEnglish = () => {
        Cookies.set('language', 'en');
    }
    const handleLanguageSpanish = () => {
        Cookies.set('language', 'es');
    }

    const language = Cookies.get('language') || 'es';
    const menuTitle = language.toUpperCase();
    return (
        <Navbar bg="light" expand="lg">
            <Container>
                <Navbar.Brand href="/">
                    {showLogo && <div className='login-brand-logo'/>}
                </Navbar.Brand>
                <div className="ms-auto basic-navbar-nav">
                        <NavDropdown title={menuTitle} id="basic-nav-dropdown">
                            <NavDropdown.Item onClick={handleLanguageEnglish} href="#">{"EN"}</NavDropdown.Item>
                            <NavDropdown.Item href="#" onClick={handleLanguageSpanish}>
                                {"ES"}
                            </NavDropdown.Item>
                        </NavDropdown>
                </div>
            </Container>
        </Navbar>
    );
}
